module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('topbar'), _vm._v(" "), _c('shortcutbar'), _vm._v(" "), _c('section', {
    staticClass: "app-main"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bdcb0a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 514
// module chunks = 22